module.exports = __webpack_public_path__ + "img/scene4-9.6cad81a1.jpg";